import React from 'react';
const faqs = [{
  q: 'Ab wann hat Marie eine Verbesserung bemerkt?',
  a: 'Bereits nach 7–10 Tagen zeigte Tony deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
}, {
  q: 'Ist das Topping auch für empfindliche Hunde geeignet?',
  a: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
}, {
  q: 'Wie viel gibt man täglich?',
  a: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Marie hat mit der kleinsten Menge angefangen und langsam gesteigert.'
}, {
  q: 'Was wenn es bei meinem Hund nicht wirkt?',
  a: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
}];
export function FaqSection() {
  return <section className="px-4 mb-12" data-id="element-90">
      <h3 className="font-handwriting text-3xl font-bold text-center text-forest mb-8" data-id="element-91">
        Häufige Fragen
      </h3>
      <div className="space-y-4 max-w-2xl mx-auto" data-id="element-92">
        {faqs.map((faq, index) => <div key={index} className="bg-card p-6 rounded-xl shadow-sm border border-brown/5" data-id="element-93">
            <h4 className="font-serif font-bold text-forest text-lg mb-2" data-id="element-94">
              {faq.q}
            </h4>
            <p className="font-serif text-text/80 text-sm leading-relaxed" data-id="element-95">
              {faq.a}
            </p>
          </div>)}
      </div>
    </section>;
}